module.exports = __webpack_public_path__ + "static/media/p_b_tex.4db4d96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/pez_b/p_b_tex.png
// module id = 143
// module chunks = 0